define('adminUserGroupsCreatePopupView',[
  'app',
  'module',
  'backbone',
  'underscore',
  'jquery',
  'marionette',
  'bootbox',
  'template!adminUserGroupsCreatePopupView',
  'entities/admin/user_groups'
], function (
  App,
  Module,
  Backbone,
  _,
  $,
  Marionette,
  Bootbox,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'admin-user-groups-popup-create-view',

    ui: {
      nameInput: '.name-input',
      searchInput: '.search-input',
      suggestions: '.suggestions',
      selectedList: '.selected-members',
      confirmButton: '.btn-confirm',
      cancelButton: '.btn-cancel'
    },

    events: {
      'input @ui.searchInput': 'onSearch',
      'click .suggestion': 'onPickSuggestion',
      'click .selected-member .remove': 'onRemoveSelected',
      'click @ui.confirmButton': 'onConfirm',
      'click @ui.cancelButton': 'onCancel'
    },

    initialize: function () {
      // Local in-memory state — members picked but not yet persisted.
      this.selected = []; // Array of { secId, firstName, lastName, email }
      this.searchTimer = null;
      this.lastSearchResults = []; // Cached so onPickSuggestion can resolve a full user from a secId
      this.pendingName = ''; // Preserve typed name across re-renders
    },

    onRender: function () {
      // Restore the in-progress name if the view has been re-rendered after
      // picking / removing a member.
      if (this.pendingName && this.ui.nameInput && this.ui.nameInput.length) {
        this.ui.nameInput.val(this.pendingName);
      }
    },

    serializeData: function () {
      return {
        placeholder: _.i18n('admin.userGroups.searchMemberPlaceholder'),
        selected: this.selected
      };
    },

    onSearch: function () {
      var query = this.ui.searchInput.val();
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      this.searchTimer = setTimeout(_.bind(function () {
        if (!query || query.length < 1) {
          this.ui.suggestions.empty().hide();
          return;
        }
        App.request('userGroups:search-userpids', query).done(_.bind(function (users) {
          this.renderSuggestions(users || []);
        }, this));
      }, this), 250);
    },

    renderSuggestions: function (users) {
      var selectedIds = _.pluck(this.selected, 'secId');
      var filtered = _.filter(users, function (u) {
        return !_.contains(selectedIds, u.secId);
      });
      this.lastSearchResults = filtered;
      var html = _.map(filtered, function (u) {
        var label = _.escape((u.firstName || '') + ' ' + (u.lastName || '') + ' <' + (u.email || '') + '>');
        return '<div class="suggestion" data-sec-id="' + _.escape(u.secId) + '">' + label + '</div>';
      }).join('');
      this.ui.suggestions.html(html).show();
    },

    onPickSuggestion: function (e) {
      // Capture whatever the user has typed into the name field before we re-render.
      this.pendingName = (this.ui.nameInput.val() || '');
      var secId = $(e.currentTarget).data('sec-id');
      var user = _.findWhere(this.lastSearchResults, { secId: secId });
      if (!user) return;
      if (!_.findWhere(this.selected, { secId: user.secId })) {
        this.selected.push(user);
      }
      this.render();
    },

    onRemoveSelected: function (e) {
      this.pendingName = (this.ui.nameInput.val() || '');
      var secId = $(e.currentTarget).data('sec-id');
      this.selected = _.reject(this.selected, function (u) { return u.secId === secId; });
      this.render();
    },

    onConfirm: function () {
      var name = (this.ui.nameInput.val() || '').trim();
      if (name === '') {
        Bootbox.alert(_.i18n('admin.userGroups.nameRequired'));
        return;
      }
      var payload = {
        name: name,
        userpidSecIds: _.pluck(this.selected, 'secId')
      };
      App.request('userGroups:create', payload).done(_.bind(function () {
        this.windowView.close();
        if (this.options.onConfirm) {
          this.options.onConfirm();
        }
      }, this)).fail(function (xhr) {
        if (xhr && xhr.status === 409) {
          Bootbox.alert(_.i18n('admin.userGroups.nameConflict'));
        } else if (xhr && xhr.status === 403) {
          Bootbox.alert(_.i18n('admin.userGroups.forbidden'));
        } else {
          Bootbox.alert(_.i18n('common.error'));
        }
      });
    },

    onCancel: function () {
      this.windowView.close();
    }
  });
});

